import React from "react";

interface Props {
  leftImageUrl?: string;
  leftImageAltText?: string;
  rightImageUrl?: string;
  rightImageAltText?: string;
  sectionTitle?: string;
  title?: string;
  subTitle?: string;
  text?: string;
}

export default function CareersIntroduction({
  leftImageUrl = "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-intro-1.1.jpg",
  leftImageAltText = "",
  rightImageUrl = "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-intro-2.jpg",
  rightImageAltText = "",
  sectionTitle = "What",
  title = "The largest online distributor",
  subTitle = "of restaurant supplies and equipment",
  text = "We sell everything from plastic cups and fine china to commercial dishwashers. Whatever our customers need, we've got it, and we'll get it to them fast. At WebstaurantStore, we're risk-takers, fast learners, and experts in our fields.",
}: Props) {
  return (
    <div className="careers-info" style={{ paddingBottom: 110 }}>
      <div
        className="careers-info__image careers-info__image--left"
        style={{ top: "-113.03px" }}
      >
        <img src={leftImageUrl} alt={leftImageAltText} />
      </div>
      <div className="careers-info-content">
        <div className="careers-section-title">{sectionTitle}</div>
        <div className="careers-info-text">
          <h2 className="careers-info__title">{title}</h2>
          <div className="careers-info__subtitle">{subTitle}</div>
          <p className="careers-info__text">{text}</p>
        </div>
      </div>
      <div
        className="careers-info__image careers-info__image--right"
        style={{ top: 140 }}
      >
        <img src={rightImageUrl} alt={rightImageAltText} />
      </div>
    </div>
  );
}
